<script>
export let rotate = false;
</script>
<style>
.rotate {
    transform: rotate(45deg);
}
</style>
<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" class:rotate>
    <path d="m12 0c6.627417 0 12 5.372583 12 12s-5.372583 12-12 12-12-5.372583-12-12 5.372583-12 12-12zm0 4c-.5522847 0-1 .44771525-1 1v6h-6c-.51283584 0-.93550716.3860402-.99327227.8833789l-.00672773.1166211c0 .5522847.44771525 1 1 1h6v6c0 .5128358.3860402.9355072.8833789.9932723l.1166211.0067277c.5522847 0 1-.4477153 1-1l-.001-6h6.001c.5128358 0 .9355072-.3860402.9932723-.8833789l.0067277-.1166211c0-.5522847-.4477153-1-1-1h-6v-6c0-.51283584-.3860402-.93550716-.8833789-.99327227z" fill="currentColor" fill-rule="evenodd"/>
</svg>
